import React from "react";

type Props = { src?: string; name?: string };

export default function ServiceRentItemImage({ src, name }: Props) {
  return (
    <div className="w-[85px] h-[85px] border border-brand-neutral-10 flex-shrink-0">
      {src ? (
        <img
          alt={`goods-${name}`}
          src={src}
          className="w-[85px] h-[83px] object-cover"
        />
      ) : (
        <div
          className="bg-brand-gray-10 w-full h-full"
          data-testid="placeholder-div"
        ></div>
      )}
    </div>
  );
}
